import { useContext } from 'react'
import { Context } from '../waxplorer/Waxplorer'
import { DropAlert } from './DropAlert'
import { useTranslation } from 'react-i18next'
import MainButton from '../common/util/input/MainButton'

export const DropNfthivedropsAuthEditor = ({
    isUserAuthor,
    isNfthivedropsAuthorized,
    collectionName,
    setIsNfthivedropsAuthorized,
}) => {
    const [, dispatch] = useContext(Context)

    const { t } = useTranslation('common')

    const handleAuthorizeNfthivedropsCallBack = (wasAdded) => {
        if (wasAdded) {
            setIsNfthivedropsAuthorized(true)
        }
    }

    const handleAuthNfthivedrops = () => {
        dispatch({
            type: 'SET_CALLBACK',
            payload: handleAuthorizeNfthivedropsCallBack,
        })
        dispatch({ type: 'SET_ACTION', payload: 'authorizeNfthivedrops' })
        dispatch({ type: 'SET_COLLECTION_NAME', payload: collectionName })
    }

    return (
        <div>
            <DropAlert
                severity="error"
                condition={
                    isUserAuthor === false && isNfthivedropsAuthorized === false
                }
            >
                {t('drops.nfthivedrops_authorized_explanation')}
            </DropAlert>

            <DropAlert
                severity="error"
                condition={isUserAuthor && isNfthivedropsAuthorized === false}
            >
                {t('drops.nfthivedrops_authorized_sign_trx')}
                <div className="mt-3 flex justify-center">
                    <MainButton onClick={handleAuthNfthivedrops}>
                        {t('drops.add_nfthivedrops_to_authorized_accounts')}
                        {collectionName}
                    </MainButton>
                </div>
            </DropAlert>

            <DropAlert
                severity="success"
                condition={isUserAuthor && isNfthivedropsAuthorized}
            >
                {t('drops.account_nfthivedrops_is_authorized')}
            </DropAlert>
        </div>
    )
}
